/**
 * LocalStorage middleware script file
 *
 * @package    Middleware
 * @author     Vadym Karpenko <vkarpenko@mindk.com>
 * @copyright  Copyright (c) 2010-2018 MindK (http://mindk.com). All rights reserved.
 * @license    http://mindk.com
 * @link       http://mindk.com
 */
import { SET_LOCALE } from 'Actions/general';
import {
    unAuthorize,
    AUTHORIZE_SUCCESS,
    UN_AUTHORIZE_SUCCESS,
    KEEP_ALIVE_SUCCESS,
    CHANGE_ROLE_SUCCESS,
} from 'Actions/auth';

export default () => store => next => action => {
    if (action.type) {
        const state = store.getState();

        switch (action.type) {
            case SET_LOCALE:
                localStorage.setItem('locale', action.locale);
                break;

            case AUTHORIZE_SUCCESS:
                localStorage.setItem('auth', JSON.stringify(action.payload));
                break;

            case UN_AUTHORIZE_SUCCESS:
                localStorage.removeItem('auth');
                break;

            case CHANGE_ROLE_SUCCESS:
                {
                    const auth = JSON.parse(localStorage.auth);
                    auth.user.activeRole = action.payload;
                    localStorage.setItem('auth', JSON.stringify(auth));
                }
                break;
            case KEEP_ALIVE_SUCCESS:
                {
                    try {
                        const data = action.payload.data;
                        if ('activeRole' in data) {
                            delete data.activeRole;
                        }
                        const auth = JSON.parse(localStorage.auth);
                        auth.user = {...auth.user, ...data};
                        localStorage.setItem('auth', JSON.stringify(auth));
                    } catch (error) {
                        localStorage.removeItem('auth');
                        if (state.auth.isLoggedIn) {
                            store.dispatch(unAuthorize());
                        }
                    }
                }
                break;
        }
    }

    return next(action);
};



// WEBPACK FOOTER //
// ./src/middleware/localStorage.js